module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki05_pc-65d060dab6be64ee78f2950b69069111.jpg";